module.exports = __webpack_public_path__ + "static/media/logo_prosinos.60419f09.png";